import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button } from '@mui/material';
import Alert from '@mui/material/Alert';
//import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { API_SERVER_FILES, API_URI_CVTheque, getCVThequeENV } from '../../config';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import StatutDocument from '../../Pages/Client/DocAdministratifs/StatutDocument';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import DocumentUpload from '../../Utils/fileUpload/DocumentUpload';
import { calculateMonthBetweenDatesISOFormat, getNomPrenomClearFromPersoData, getTimeFromIsoFormatDate, SpliUrl } from '../../Utils/utils';
//import { stylebuttonsubmit } from '../shared/MuiSharedElements';
import { DatePickerComponent } from '../shared/ReusableSmallComponents';
import { buttonStyles,buttonStylesBlue } from './JsObjectStyles';

function AttestationFiscale() {

    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const { i18n } = useTranslation();
    const [url, setUrl] = useState('');
    const [documentAdministratifs, setDocumentAdministratifs] = useState([]);
    const [fiscalitymessage, setFiscalitymessage] = React.useState('');
    const [fiscalitystatus, setFiscalitystatus] = React.useState('');
    const [attestationFiscale, setAttestationFiscale] = useState('');
    const {device}=useWindowSize();
    const [dateEmission, setDateEmission] = React.useState(null);
    const [dateValidite, setDateValidite] = React.useState('');

    useEffect(() => {
        if (attestationFiscale !== '') {
            uploadDocFile();
        }
    }, [attestationFiscale]);

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, []);

    useEffect(() => {
        getDocumentAdministratifs();
    }, []);

    const getDocumentAdministratifs = async () => {
        var temp = [];
        try {
            console.log('HELLO FROM the get doc adminitratifs a valider Client useEffect');
            const response = await axiosPrivate.get('docAdministratif/getMyDocsAdministratifs');
            console.log('response', response.data);
            response.data.forEach(element => {
                if (element?.titre == 'attestationFiscale')
                    temp.push(element);
            });
            setDocumentAdministratifs(temp.reverse());
        } catch (error) {
            console.log(error);
        }
    };

    const supprimerDocument = async (docId) => {
        try {
            const response1 = await axiosPrivate.delete(
                'docAdministratif/deleteDocAdministratif/' + docId,
            );
            console.log('delete msg', response1);
            getDocumentAdministratifs();

        } catch (error) {
            console.log(error.response?.status);
        }
    };

    const checkExpiredDocument = async (dateDelivrance) => {
        const currentDate = new Date();
        const temp=new Date(dateDelivrance);
        const expirationDate=temp.setFullYear(temp.getFullYear() + 1);
        console.log('expirationDate after 1 year',expirationDate);
        if(new Date(expirationDate)<currentDate){
            setFiscalitymessage(i18n.t('Votre attestation fiscale est expirée depuis le ')+formatDateJJMMYYYY(new Date(expirationDate))+i18n.t(', veuillez la renouveler'));
            setFiscalitystatus('fiscalitynonvalide');
        }
        else{
            setFiscalitymessage(i18n.t('Votre attestation fiscale sera valable jusqu\'au ')+ formatDateJJMMYYYY(new Date(expirationDate)));
            setFiscalitystatus('fiscalityvalide');
        }
    };
    useEffect(() =>{
        if(dateEmission){
            const temp=new Date(dateEmission);
            checkExpiredDocument(dateEmission);
            setDateValidite(new Date(temp.setFullYear(temp.getFullYear() + 1)));
        }
    }, [dateEmission]);

    const uploadDocFile = async () => {
        console.log('URL \n\n');
        const formData = new FormData();
        console.log(url,);
        setBackdropOpen(true);
        try {
            formData.append('file', attestationFiscale);
            formData.append('q', 'attestationFiscale');
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.post(
                    '/proxy/uploadDocFile',
                    formData,
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadDocFile', {
                    method: 'Post',
                    // headers: {
                    //     'Content-Type': 'multipart/form-data',
                    //     'accept': 'application/json'
                    // },
                    body: formData,
                });
                responseData1 = await response1.json();
            }

            console.log('submitresumeBackend', responseData1);
            setDateEmission(responseData1?.dateExtraction);
            //setFiscalitystatus(responseData1?.fiscalityvalide);
            //setFiscalitymessage(responseData1?.validityfiscalitymessage);
            //setDateValidite(responseData1?.dateValidite);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
            setBackdropOpen(false);
        }
    };

    const uploadToBackend = async (URL) => {
        console.log('URL \n\n', URL);
        const formData = new FormData();
        setBackdropOpen(true);
        try {
            formData.append('attestationFiscale', attestationFiscale); //kbis , urssaf ....
            if (dateEmission)
                formData.append('dateEmission', dateEmission);
            if (dateValidite)
                formData.append('dateValidite', dateValidite);
            // formData.append('dateValidite',(new Date(dateValidite)).toISOString());
            const response1 = await axiosPrivate.post(
                '/docAdministratif/uploadDocumentOnly',
                formData,
            );
            const responseData1 = await response1.data;
            console.log('submitresumeBackend', responseData1);
            setDateEmission(null);
            setDateValidite(null);
            setFiscalitystatus('');
            setFiscalitymessage('');
            setAttestationFiscale('');
            getDocumentAdministratifs();
        } catch (error) {
            console.log(error.response?.status, error.response.data?.error);
            // ! kbis already uploaded
            // ! cas Kbis not fount
            // if (error.response?.status == 404) {
            //     navigate('/client/completeProfile/step4', {
            //         state: {
            //             state
            //         }
            //     });
            // }
        }
        setBackdropOpen(false);
    };

    return (
        <div className='identitystyleKbis2'>
            <div className='frame1KbisClient'>
                <h4 className='titlesociete'>{i18n.t('Attestation fiscale')}</h4>

                {fiscalitystatus == 'fiscalityvalide' && (<div><Alert severity="success">{fiscalitymessage}</Alert></div>)}
                {fiscalitystatus == 'fiscalitynonvalide' && (<div><Alert severity="error">{fiscalitymessage}</Alert></div>)}
                <div className='frame2KbisClient'>
                    <p className='telechrgestyle'>{i18n.t('Télécharger l\'attestation fiscale')} </p>
                    <DocumentUpload
                        required
                        setFile={setAttestationFiscale}
                        document={attestationFiscale}
                    />
                </div>
                <div className='resultocrstyle'>
                    <div className='outresultocr'>
                        <DatePickerComponent
                            label={i18n.t('Date de délivrance')}
                            date={dateEmission}
                            setDate={(newValue) => {
                                //j'ai ajouter then prcq ca pose un problem au niveau de set du dateEmission
                                //let temp = newValue;
                                setDateEmission(newValue);
                                //setDateValidite(moment(temp).add('years', 1));
                            }}
                            disabled={attestationFiscale ? false : true}
                            width={'100%'}
                        />
                    </div>
                </div>
                <div className='outsidesubmitbtnstyle'>
                    <Button
                        variant="contained"
                        type="submit"
                        style={{...buttonStylesBlue(((dateEmission!=null) ? false : true)),...{width:device=='desktop'?'auto':'100%'}}}
                        disabled={(dateEmission!=null) ? false : true}
                        onClick={uploadToBackend}
                    >
                        {i18n.t('Valider')}
                    </Button>
                </div>
            </div>
            <div className='lineSeparator'></div>
            <div className='frame0KbisClient'>
                {
                    documentAdministratifs?.map((element, idx) => (
                        <div
                            className='frame3Kbis'
                            key={idx}
                        >
                            <div className='frame4Kbis'>
                                <div className='frame5Kbis'>
                                    <div className='frame6Kbis'>
                                        <svg
                                            width="19"
                                            height="25"
                                            viewBox="0 0 19 25"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M17.1926 4.65625L13.677 1.14062C13.1145 0.578125 12.3645 0.25 11.5676 0.25H3.08325C1.39575 0.25 0.083252 1.60938 0.083252 3.25V21.25C0.083252 22.9375 1.39575 24.25 3.08325 24.25H15.0833C16.7239 24.25 18.0833 22.9375 18.0833 21.25V6.76562C18.0833 5.96875 17.7551 5.21875 17.1926 4.65625ZM15.8333 21.25C15.8333 21.6719 15.4583 22 15.0833 22H3.08325C2.66138 22 2.33325 21.6719 2.33325 21.25V3.29688C2.33325 2.875 2.66138 2.54688 3.08325 2.54688H10.5833V6.25C10.5833 7.09375 11.2395 7.75 12.0833 7.75H15.7864V21.25H15.8333ZM9.552 13.7031C9.552 13.5625 9.59888 13.4219 9.64575 13.2812C9.7395 13.0469 10.0208 11.8281 10.0208 10.8438C10.0208 9.95312 9.31763 9.25 8.427 9.25C7.58325 9.25 6.88013 9.95312 6.88013 10.8438C6.88013 10.8438 6.88013 12.2031 7.4895 13.75C7.16138 14.6875 6.78638 15.5781 6.31763 16.4688C5.33325 16.9375 4.4895 17.5 3.83325 18.1562C3.552 18.4844 3.41138 18.8594 3.41138 19.3281C3.41138 20.1719 4.1145 20.875 4.95825 20.875C5.47388 20.875 5.94263 20.6406 6.27075 20.2188C6.59888 19.75 7.1145 19 7.677 17.9688C8.427 17.6406 9.27075 17.4062 10.2083 17.2188C10.8176 17.6406 11.5676 18.0156 12.3645 18.25C12.552 18.3438 12.7864 18.3906 13.0208 18.3906C13.9583 18.3906 14.7083 17.6406 14.7083 16.6562C14.7083 15.7188 13.9583 14.9219 12.9739 14.9219H12.8333C12.6926 14.9219 11.8489 14.9688 10.677 15.1562C10.2083 14.7344 9.83325 14.2656 9.552 13.7031ZM5.2395 19.5156C5.052 19.75 4.677 19.6562 4.677 19.2812C4.677 19.1875 4.677 19.0938 4.72388 19.0469C5.14575 18.625 5.66138 18.25 6.22388 17.9219C5.802 18.7188 5.427 19.2344 5.2395 19.5156ZM8.427 10.5156C8.6145 10.5156 8.75513 10.6562 8.75513 10.8438C8.75513 11.5469 8.56763 12.4844 8.47388 12.8125C8.14575 11.7344 8.09888 10.9375 8.09888 10.8438C8.09888 10.6562 8.2395 10.5156 8.427 10.5156ZM7.677 16.6094C7.95825 15.9531 8.28638 15.25 8.56763 14.5C8.89575 15.0156 9.27075 15.5312 9.7395 16C9.08325 16.1406 8.38013 16.3281 7.677 16.6094ZM12.8333 16.1875H12.9739C13.2551 16.1875 13.4426 16.375 13.4426 16.7031C13.4426 16.9375 13.2551 17.125 13.0208 17.125C12.927 17.125 12.8333 17.125 12.7395 17.0781C12.177 16.8906 11.6614 16.6562 11.2395 16.375C12.177 16.2344 12.8333 16.1875 12.8333 16.1875Z"
                                                fill="#272D3C"
                                            />
                                        </svg>
                                    </div>
                                    <a
                                        href={API_SERVER_FILES + encodeURIComponent(element?.url)}
                                        className='frame7Kbis'
                                        target='_blank'
                                        rel="noreferrer"
                                    >
                                        {SpliUrl(element?.url)}
                                    </a>
                                </div>
                                <StatutDocument
                                    statut={element?.statut}
                                    motifRejet={element?.motifRejet}
                                />

                                {/*<div className='frame20Kbis'>
                                    <div className='frame21Kbis'>
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M11.8125 6.40234C11.4609 6.08594 10.9336 6.08594 10.6172 6.40234L9 8.08984L7.3125 6.40234C6.96094 6.08594 6.43359 6.08594 6.11719 6.40234C5.76562 6.75391 5.76562 7.28125 6.11719 7.59766L7.76953 9.25L6.15234 10.9023C5.80078 11.2539 5.80078 11.7812 6.15234 12.0977C6.46875 12.4492 6.99609 12.4492 7.3125 12.0977L9 10.4453L10.6523 12.0977C10.9688 12.4492 11.4961 12.4492 11.8125 12.0977C12.1641 11.7812 12.1641 11.2539 11.8125 10.9023L10.1602 9.25L11.8125 7.59766C12.1641 7.28125 12.1641 6.75391 11.8125 6.40234ZM9 0.25C4.00781 0.25 0 4.29297 0 9.25C0 14.2422 4.00781 18.25 9 18.25C13.957 18.25 18 14.2422 18 9.25C18 4.29297 13.957 0.25 9 0.25ZM9 16.5625C4.95703 16.5625 1.6875 13.293 1.6875 9.25C1.6875 5.24219 4.95703 1.9375 9 1.9375C13.0078 1.9375 16.3125 5.24219 16.3125 9.25C16.3125 13.293 13.0078 16.5625 9 16.5625Z"
                                                fill="#DA251F"
                                            />
                                        </svg>

                                    </div>
                                    <p className='frame22Kbis'>
                                        {element?.statut}
                                    </p>
                                </div>*/}
                            </div>
                            <div className='frame8Kbis'>
                                <div className='frame9Kbis'>
                                    <p className='frame10Kbis'>
                                        {i18n.t('Date de l\'extrait')}: {formatDateJJMMYYYY(element?.dateEmission)}
                                    </p>
                                    <p className='frame10Kbis'>
                                        {i18n.t('Date de validité')}: {formatDateJJMMYYYY(element?.dateValidite)}
                                    </p>
                                    <p className='frame10Kbis'>
                                        {i18n.t('Téléchargé par')}: {getNomPrenomClearFromPersoData(element?.expertId?.persoData ?? element?.collaboratorEsnId?.persoData)}
                                    </p>

                                </div>
                                <div className='frame14Kbis'>
                                    <p className='frame10Kbis'>
                                        {i18n.t('Ancienneté de l\'extrait')}: {calculateMonthBetweenDatesISOFormat((new Date().toISOString()), element?.dateEmission)} mois
                                    </p>
                                    <p className='frame10Kbis'>
                                        {i18n.t('Date de téléchargement')}: {formatDateJJMMYYYY(element?.createdAt)} à {getTimeFromIsoFormatDate(element?.createdAt)}
                                    </p>

                                    {/*<p className='frame12Kbis'>
                                            Nom de la Société: {element?.expertId?.profileEntreprise?.nom}
                                    </p>*/}
                                    {/*<p className='frame13Kbis'>
                                            N°SIREN: 15840909898687
                                    </p>*/}
                                </div>
                            </div>
                            {(element?.statut == 'encours' || element?.statut == 'rejete') &&
                                <div className='frame15Kbis'>
                                    <div className='frame16Kbis'>
                                        <Button
                                            variant="text"
                                            startIcon={<DeleteForeverIcon />}
                                            style={{...buttonStyles(),...{color:'#EC5B56'}}}
                                            //color="error"
                                            onClick={() => {
                                                supprimerDocument(element?._id);
                                            }}
                                        >
                                            {i18n.t('Supprimer')}
                                        </Button>
                                    </div>
                                    {/*<div className='frame16Kbis'>
                                        <div className='frame17Kbis'>
                                            <Button
                                                variant="contained"

                                            >
                                                Rejeter
                                            </Button>
                                        </div>
                                        <div className='frame18Kbis'>
                                            <Button
                                                variant="contained"

                                            >
                                                Valider
                                            </Button>
                                        </div>
                                    </div>*/}
                                </div>
                            }
                        </div>
                    ))
                }

            </div>
        </div>
    );

}
export default AttestationFiscale;